<template>
	<v-container>
		<v-row justify="center" class="secondary--text title my-2">
			{{'About us' | localize }}
		</v-row>
		
		<v-container v-if="!loading">
			<v-row justify="center" class="ma-12">
				<v-col cols="12" 
					class="text-center font-weight-bold display-3 secondary--text">
					1 {{'dream' | localize }}
				</v-col>

				<v-col class="text-center" offset-sm="2">
					<div class="font-weight-semibold display-2 secondary--text">
						2 
					</div>
					<div>{{'business trainers' | localize }}</div>
				</v-col>
				<v-col class="text-center">
					<div class="font-weight-semibold display-2 secondary--text">
						3
					</div>
					<div>{{'employees' | localize }}</div>
				</v-col>
				<v-col class="text-center">
					<div class="font-weight-semibold display-2 secondary--text">
						25+ 
					</div>
					<div>{{'hours of business game' | localize }}</div>
				</v-col>
				<v-col></v-col>
						
			</v-row>
			<v-divider></v-divider> 
			<v-row justify="center" class="secondary--text title my-2">
				{{'Our team' | localize }}
			</v-row>
			<v-row justify="center" class="my-4">
				<v-col class="text-center" offset-md="1">
					<v-avatar size="120">
						<v-img
							src="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/team%2FSerghey_Tkachenko.jpg?alt=media&token=1ef3c9c0-2f8b-4321-b025-80140ddfd2b3"
						></v-img>
					</v-avatar>
					<div>{{'Serghei Tkachenko' | localize }}</div> 
				</v-col>
				<v-col class="text-center mr-12">
					<v-avatar size="120">
						<v-img
							src="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/team%2FNatalia.JPG?alt=media&token=84a9b513-9202-46ef-8ec7-f1de0f1f5bd9"
						></v-img>
					</v-avatar>
				<div>{{'Nataliya Zharko' | localize }}</div>
				</v-col>
			</v-row>
		</v-container>
		<v-row v-else justify="center">
			<loader></loader>
		</v-row>			
	</v-container>
</template>
<script>
import Loader from '../layouts/Loader.vue'
export default {
	data () {
		return {}
	},
	computed: {
		loading() {
			return this.$store.getters.loading;
		},
		locale() {
			return this.$store.getters.locale;
		}
	},
	components: {Loader}
}	
</script>
